import { jsx as _jsx } from "react/jsx-runtime";
export default function UICheckmark(props) {
  return /*#__PURE__*/_jsx("svg", {
    role: "presentation",
    viewBox: "0 0 15 15.343",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", Object.assign({}, props, {
      d: "M1.013 8.11c0-.223.078-.412.234-.568l1.14-1.14c.155-.155.345-.233.568-.233s.413.077.57.233l2.46 2.47 5.492-5.5c.156-.156.346-.234.568-.234.224 0 .413.077.57.233l1.138 1.14c.156.155.234.345.234.568 0 .224-.078.414-.234.57l-6.06 6.06-1.14 1.14c-.155.155-.345.233-.568.233s-.413-.078-.57-.234l-1.138-1.14-3.03-3.03c-.156-.156-.234-.346-.234-.57z"
    }))
  });
}
UICheckmark.displayName = 'UICheckmark';